document.addEventListener('DOMContentLoaded', () => {
  initCategoryScroller()
})

function initCategoryScroller() {
  const listEl = document.querySelector('.js-category-scroller')

  if (!listEl) return

  const loaderEl = document.querySelector('.js-infinite-loader')
  const limit = listEl.querySelector('input[name="limit"]').value
  const total = listEl.querySelector('input[name="total"]').value
  let page = 1
  let loading = false
  let finished = false

  function loadNextPage() {
    if (loading || finished) return
    const currentCount = listEl.querySelectorAll('.js-category-grid').length

    if (currentCount >= total) {
      finished = true
      return
    }

    loading = true
    page += 1
    loaderEl.style.display = 'block'

    const url = new URL(window.location.href)
    url.searchParams.set('page', page)
    url.searchParams.set('limit', limit)
    url.searchParams.set('scroller', '1')

    fetch(url.toString())
      .then(response => response.text())
      .then(html => {
        loaderEl.style.display = 'none'
        loading = false

        if (!html.trim()) {
          finished = true
          return
        }

        const tmp = document.createElement('div')
        tmp.innerHTML = html

        const items = tmp.querySelectorAll('.js-category-card')

        if (!items.length) {
          finished = true
          return
        }

        listEl.appendChild(tmp)


        const newCount = listEl.querySelectorAll('.js-category-card').length
        if (newCount >= total) {
          finished = true
        }
      })
      .catch(() => {
        loaderEl.style.display = 'none'
        loading = false
      })
  }

  window.addEventListener('scroll', function () {
    if (finished || loading || !listEl) return

    const scrollPosition = window.innerHeight + window.scrollY
    const containerBottom = listEl.offsetTop + listEl.offsetHeight
    const threshold = containerBottom - 100

    if (scrollPosition >= threshold) {
      loadNextPage()
    }
  })
}